import { cn } from "@omni/utils/styles";

import { Anchor } from "@/components/General/Anchor/anchor.component";
import {
    useCategoryContext,
    useSubCategory
} from "@/components/General/FlyoutMenu/context/category.context";
import { useFlyoutMenuContext } from "@/components/General/FlyoutMenu/context/flyoutMenu.context";
import { useMapped } from "@/context/mapped.context";

type Props = {
    className?: string;
};

export const Link = ({ className }: Props) => {
    const { activeCategoryIndexes } = useFlyoutMenuContext();
    const {
        index: categoryIndex,
        onMouseEnter,
        onMouseLeave
    } = useCategoryContext();
    const { index: subCategoryIndex } = useMapped();
    const { category } = useSubCategory(subCategoryIndex);

    if (!category) return null;

    const active = activeCategoryIndexes[categoryIndex] === subCategoryIndex;

    const handleOnMouseEnter = () => {
        onMouseEnter(subCategoryIndex);
    };

    const handleOnMouseLeave = () => {
        onMouseLeave();
    };

    return (
        <li
            className={className}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
        >
            <Anchor
                color={"link"}
                fullWidth={true}
                className={cn("tw:text-left", {
                    "tw:border-l-5 tw:border-danger tw:bg-grey tw:-indent-1.25 tw:underline":
                        active,
                    "tw:hover:no-underline": !active
                })}
                href={category.url}
            >
                {category.title}
            </Anchor>
        </li>
    );
};
